const crystalMinTimeToAppear = 16000
const levels = [
  {
    id: 1,
    arena: {
      name: 'Granite',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#999999',
      walls: [],
    },
    crystals: [{
      type: 'grow',
      position: [0, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear, // ms
    }],
    player: {
      position: [-5.1, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 2,
    }],
  }, {
    id: 2,
    arena: {
      name: 'Sand',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#9c6135',
      walls: [],
    },
    crystals: [{
      type: 'coil',
      position: [0, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear, // ms
    }],
    player: {
      position: [-5.1, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 2,
    }, {
      id: 'enemy2',
      position: [-5.1, 0.22, -5.1],
      color: '#9e18aa',
      spin: 'ccw',
      model: 3,
    }],
  }, {
    id: 3,
    arena: {
      name: 'Malaquite',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#60944a',
      walls: [],
    },
    crystals: [{
      type: 'freezer',
      position: [0, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear, // ms
    }],
    player: {
      position: [-5.1, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 2,
    }, {
      id: 'enemy2',
      position: [-5.1, 0.22, -5.1],
      color: '#9e18aa',
      spin: 'ccw',
      model: 3,
    }, {
      id: 'enemy3',
      position: [5.1, 0.22, 5.1],
      color: '#9e18aa',
      model: 4,
    }],
  }, {
    id: 4,
    arena: {
      name: 'Turquoise',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#479186',
      walls: [{
        color: '#479186',
        rotate: Math.PI / 2,
        position: [0, -0.22, -8],
      }, {
        color: '#479186',
        rotate: Math.PI / 2,
        position: [-4, -0.22, -8],
      }, {
        color: '#479186',
        rotate: Math.PI / 2,
        position: [4, -0.22, -8],
      }, {
        color: '#479186',
        rotate: Math.PI / 2,
        position: [0, -0.22, 8],
      }, {
        color: '#479186',
        rotate: Math.PI / 2,
        position: [-4, -0.22, 8],
      }, {
        color: '#479186',
        rotate: Math.PI / 2,
        position: [4, -0.22, 8],
      }],
    },
    crystals: [{
      type: 'grow',
      position: [-4, 0.21, 4],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'coil',
      position: [0, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'freezer',
      position: [4, 0.21, -4],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [-5.1, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 2,
    }, {
      id: 'enemy2',
      position: [-5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy3',
      position: [5.1, 0.22, 5.1],
      color: '#9e18aa',
      model: 4,
    },],
  }, {
    id: 5,
    arena: {
      name: 'Aragonite',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#ff5e00',
      walls: [{
          color: '#ff5e00',
          position: [-8, -0.22, 0],
       }, {
         color: '#ff5e00',
         position: [8, -0.22, 0],
       }, {
         color: '#ff5e00',
         rotate: Math.PI / 2,
         position: [0, -0.22, -8],
       }, {
         color: '#ff5e00',
         rotate: -Math.PI / 2,
         position: [0, -0.22, 8],
       }],
    },
    crystals: [{
      type: 'freezer',
      position: [-4, 0.21, -4],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'grow',
      position: [0, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'coil',
      position: [4, 0.21, 4],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [0, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [5.1, 0.22, 0],
      color: '#9e18aa',
      model: 2,
    }, {
      id: 'enemy2',
      position: [-5.1, 0.22, 0],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy3',
      position: [0, 0.22, -5.1],
      color: '#9e18aa',
      model: 4,
    }],
  }, {
    id: 6,
    arena: {
      name: 'Jasper',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#ad1a2b',
      walls: [{
          color: '#ad1a2b',
          position: [-8, -0.22, -5.5],
       }, {
          color: '#ad1a2b',
          rotate: Math.PI / 2,
          position: [-5.5, -0.22, -8],
       }, {
          color: '#ad1a2b',
          position: [8, -0.22, 5.5],
       }, {
          color: '#ad1a2b',
          position: [8, -0.22, -5.5],
       }, {
         color: '#ad1a2b',
         rotate: Math.PI / 2,
         position: [5.5, -0.22, -8],
       }, {
         color: '#ad1a2b',
         rotate: Math.PI / 2,
         position: [5.5, -0.22, 8],
       }, {
         color: '#ad1a2b',
         rotate: -Math.PI / 2,
         position: [-5.5, -0.22, 8],
       }, {
          color: '#ad1a2b',
          position: [-8, -0.22, 5.5],
       }],
    },
    crystals: [{
      type: 'coil',
      position: [5, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'freezer',
      position: [0, 0.21, 5],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'grow',
      position: [-5, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [-5.1, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [5.1, 0.22, 5.1],
      color: '#9e18aa',
      model: 2,
    }, {
      id: 'enemy2',
      position: [-5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy3',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 4,
    }],
  }, {
    id: 7,
    arena: {
      name: 'Amethyst',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#471182',
      walls: [{
          color: '#471182',
          position: [-8, -0.22, 0],
       }, {
          color: '#471182',
          position: [8, -0.22, 0],
       }],
    },
    spinReverseAreas: [{
      position: [0, 0, 0],
      hx: 14,
      hy: 0.5,
      // rotate: Math.PI / 4,
    }],
    crystals: [{
      type: 'grow',
      position: [-5, 0.21, -1],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'coil',
      position: [-5, 0.21, 5],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'freezer',
      position: [5, 0.21, 5],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [0, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [-5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy2',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy3',
      position: [0, 0.22, -5.1],
      color: '#9e18aa',
      model: 4,
    }],
  }, {
    id: 8,
    arena: {
      name: 'Topaz',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#1676a6',
      walls: [{
          // West-Middle
          color: '#1676a6',
          position: [-8, -0.22, 0],
       }, {
          // West-North
          color: '#1676a6',
          position: [-8, -0.22, -6],
       }, {
          // North-West
          color: '#1676a6',
          rotate: Math.PI / 2,
          position: [-6, -0.22, -8],
       }, {
          // Morth-Middle
          color: '#1676a6',
          rotate: Math.PI / 2,
          position: [0, -0.22, -8],
       }, {
          // East-North
          color: '#1676a6',
          position: [8, -0.22, -6],
       }, {
          // East-South
          color: '#1676a6',
          position: [8, -0.22, 6],
       }, {
          // South-East
          color: '#1676a6',
          rotate: Math.PI / 2,
          position: [6, -0.22, 8],
       }, {
          // North-East
          color: '#1676a6',
          rotate: Math.PI / 2,
          position: [5.5, -0.22, -8],
       },{
          // West-South
          color: '#1676a6',
          position: [-8, -0.22, 6],
       }, {
          // South-West
          color: '#1676a6',
          rotate: -Math.PI / 2,
          position: [-5.5, -0.22, 8],
       }, {
          // South-Middle
          color: '#1676a6',
          rotate: Math.PI / 2,
          position: [0, -0.22, 8],
       }, {
          // Middle-Cross
          color: '#1676a6',
          position: [8, -0.22, 0],
       }],
    },
    spinReverseAreas: [{
      position: [-2, 0, -2],
      hx: 2,
      hy: 2,
      // rotate: Math.PI / 4,
    }, {
      position: [2, 0, 2],
      hx: 2,
      hy: 2,
      // rotate: Math.PI / 4,
    }, {
      position: [2, 0, -2],
      hx: 2,
      hy: 2,
      // rotate: Math.PI / 4,
    }, {
      position: [-2, 0, 2],
      hx: 2,
      hy: 2,
      // rotate: Math.PI / 4,
    }],
    crystals: [{
      type: 'freezer',
      position: [2, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'grow',
      position: [-2, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'coil',
      position: [0, 0.21, -2],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [-5.1, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [-5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 3
    }, {
      id: 'enemy2',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 4
    }, {
      id: 'enemy3',
      position: [5.1, 0.22, 5.1],
      color: '#9e18aa',
      spin: 'ccw',
      model: 3,
    }],
  }, {
    id: 9,
    arena: {
      name: 'Sulfur',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#ebb800',
      walls: [{
          color: '#ff5e00',
          position: [-8, -0.22, 0],
       }, {
         color: '#ff5e00',
         position: [8, -0.22, 0],
       }, {
         color: '#ff5e00',
         rotate: Math.PI / 2,
         position: [0, -0.22, -8],
       }, {
         color: '#ff5e00',
         rotate: -Math.PI / 2,
         position: [0, -0.22, 8],
       }],
    },
    spinReverseAreas: [{
      position: [-5, 0, 0],
      hx: 2,
      hy: 8,
      // rotate: Math.PI / 4,
    }, {
      position: [5, 0, 0],
      hx: 2,
      hy: 8,
      // rotate: Math.PI / 4,
    }, {
      position: [0, 0, -5],
      hx: 8,
      hy: 2,
      // rotate: Math.PI / 4,
    }, {
      position: [0, 0, 5],
      hx: 8,
      hy: 2,
      // rotate: Math.PI / 4,
    }],
    crystals: [{
      type: 'coil',
      position: [0, 0.21, 7],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'freezer',
      position: [-7, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'grow',
      position: [7, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [0, 0.22, 0],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy2',
      position: [-5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy3',
      position: [-5.1, 0.22, 5.1],
      color: '#9e18aa',
      model: 4
    }, {
      id: 'enemy4',
      position: [5.1, 0.22, 5.1],
      color: '#9e18aa',
      model: 4,
    }],
  }, {
    id: 10,
    arena: {
      name: 'Graphite',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#33312f',
      walls: [{
          // West-Middle
          color: '#33312f',
          position: [-8, -0.22, 0],
       }, {
          // West-North
          color: '#33312f',
          position: [-8, -0.22, -6],
       }, {
          // North-West
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [-6, -0.22, -8],
       }, {
          // Morth-Middle
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [0, -0.22, -8],
       }, {
          // East-North
          color: '#33312f',
          position: [8, -0.22, -6],
       }, {
          // East-South
          color: '#33312f',
          position: [8, -0.22, 6],
       }, {
          // South-East
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [6, -0.22, 8],
       }, {
          // North-East
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [5.5, -0.22, -8],
       },{
          // West-South
          color: '#33312f',
          position: [-8, -0.22, 6],
       }, {
          // South-West
          color: '#33312f',
          rotate: -Math.PI / 2,
          position: [-5.5, -0.22, 8],
       }, {
          // South-Middle
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [0, -0.22, 8],
       }, {
          // Middle-Cross
          color: '#33312f',
          position: [8, -0.22, 0],
       }],
    },
    spinReverseAreas: [{
      position: [0, 0, 0],
      hx: 14,
      hy: 0.5,
      // rotate: Math.PI / 4,
    }],
    crystals: [{
      type: 'coil',
      position: [0, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'freezer',
      position: [-5, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'grow',
      position: [5, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [-5.1, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [-0, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy2',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy3',
      position: [5.1, 0.22, 1],
      color: '#9e18aa',
      model: 4,
    }, {
      id: 'enemy4',
      position: [5.1, 0.22, -1],
      color: '#9e18aa',
      model: 4,
    }],
    portalGroups: [
      [{ position: [-6, -0.3, -6]}, {position: [6, -0.3, 6]}],
    ],
  }, {
    id: 11,
    arena: {
      name: 'The roof',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#33312f',
      walls: [{
          // West-Middle
          color: '#33312f',
          position: [-8, -0.22, 0],
       }, {
          // West-North
          color: '#33312f',
          position: [-8, -0.22, -6],
       }, {
          // North-West
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [-6, -0.22, -8],
       }, {
          // Morth-Middle
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [0, -0.22, -8],
       }, {
          // East-North
          color: '#33312f',
          position: [8, -0.22, -6],
       }, {
          // East-South
          color: '#33312f',
          position: [8, -0.22, 6],
       }, {
          // South-East
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [6, -0.22, 8],
       }, {
          // North-East
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [5.5, -0.22, -8],
       },{
          // West-South
          color: '#33312f',
          position: [-8, -0.22, 6],
       }, {
          // South-West
          color: '#33312f',
          rotate: -Math.PI / 2,
          position: [-5.5, -0.22, 8],
       }, {
          // South-Middle
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [0, -0.22, 8],
       }, {
          // Middle-Cross
          color: '#33312f',
          position: [8, -0.22, 0],
       }],
    },
    spinReverseAreas: [{
      position: [-6, -0.3, -6],
      hx: 2,
      hy: 2,
    }, {
      position: [-6, -0.3, 6],
      hx: 2,
      hy: 2,
    }],
    crystals: [{
      type: 'freezer',
      position: [6, 0.21, 6],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'coil',
      position: [-6, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'grow',
      position: [6, 0.21, -6],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [-5.1, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [0, 0.22, -5.1],
      color: '#9e18aa',
      model: 3,
    }, {
      id: 'enemy2',
      position: [2.5, 0.22, -5.1],
      color: '#9e18aa',
      spin: 'ccw',
      model: 3,
    }, {
      id: 'enemy3',
      position: [5.1, 0.22, -2.5],
      color: '#9e18aa',
      model: 4,
    }, {
      id: 'enemy4',
      position: [5.1, 0.22, 0],
      color: '#9e18aa',
      spin: 'ccw',
      model: 4,
    }],
    portalGroups: [
      [{ position: [-6, -0.3, -6]}, {position: [6, -0.3, 6]}],
      [{ position: [-6, -0.3, 6]}, {position: [6, -0.3, -6]}],
    ],
  }, {
    id: 12,
    arena: {
      name: 'The castle',
      // texture: require('../../assets/textures/cube_rock_A_mat_baseColor.png'),
      tint: '#33312f',
      walls: [{
          // West-Middle
          color: '#33312f',
          position: [-8, -0.22, 0],
       }, {
          // West-North
          color: '#33312f',
          position: [-8, -0.22, -6],
       }, {
          // North-West
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [-6, -0.22, -8],
       }, {
          // Morth-Middle
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [0, -0.22, -8],
       }, {
          // East-North
          color: '#33312f',
          position: [8, -0.22, -6],
       }, {
          // East-South
          color: '#33312f',
          position: [8, -0.22, 6],
       }, {
          // South-East
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [6, -0.22, 8],
       }, {
          // North-East
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [5.5, -0.22, -8],
       },{
          // West-South
          color: '#33312f',
          position: [-8, -0.22, 6],
       }, {
          // South-West
          color: '#33312f',
          rotate: -Math.PI / 2,
          position: [-5.5, -0.22, 8],
       }, {
          // South-Middle
          color: '#33312f',
          rotate: Math.PI / 2,
          position: [0, -0.22, 8],
       }, {
          // Middle-Cross
          color: '#33312f',
          position: [8, -0.22, 0],
       }, {
          // Xtra 1
          color: '#262523',
          rotate: Math.PI / 2,
          position: [-2.5, -0.22, 7.5],
       }, {
          // Xtra 2
          color: '#262523',
          rotate: Math.PI / 2,
          position: [3, -0.22, 7.5],
       }, {
          // Xtra 3
          color: '#262523',
          rotate: Math.PI / 2,
          position: [2.5, -0.22, -7.5],
       }, {
          // Xtra 4
          color: '#262523',
          rotate: Math.PI / 2,
          position: [-3, -0.22, -7.5],
       }, {
          // Xtra 5
          color: '#262523',
          position: [-7.5, -0.22, -3],
       }, {
          // Xtra 6
          color: '#262523',
          position: [7.5, -0.22, -3],
       }, {
          // Xtra 7
          color: '#262523',
          position: [7.5, -0.22, 3],
       }, {
          // Xtra 8
          color: '#262523',
          position: [-7.5, -0.22, 3],
       }],
    },
    spinReverseAreas: [{
      position: [0, 0, 0],
      hx: 4,
      hy: 4,
    }],
    crystals: [{
      type: 'coil',
      position: [6, 0.21, 6],
      timeToAppear: crystalMinTimeToAppear, // ms
    }, {
      type: 'grow',
      position: [-6, 0.21, 0],
      timeToAppear: crystalMinTimeToAppear * 2.5, // ms
    }, {
      type: 'freezer',
      position: [6, 0.21, -6],
      timeToAppear: crystalMinTimeToAppear * 3.5, // ms
    }],
    player: {
      position: [0, 0.22, 5.1],
      color: '#0ac757',
    },
    enemies: [{
      id: 'enemy1',
      position: [-2.5, 0.22, -5.1],
      color: '#9e18aa',
      model: 4,
    }, {
      id: 'enemy2',
      position: [-5.1, 0.22, -5.1],
      color: '#9e18aa',
      spin: 'ccw',
      model: 4,
    }, {
      id: 'enemy3',
      position: [2.5, 0.22, -5.1],
      color: '#9e18aa',
      model: 4,
    }, {
      id: 'enemy4',
      position: [5.1, 0.22, -5.1],
      color: '#9e18aa',
      spin: 'ccw',
      model: 4,
    }],
    portalGroups: [
      [{ position: [-5.1, 0, 0]}, {position: [5.1, 0, 0]}],
    ],
  }
]


export default levels
